export const hasVariance = ({
    current,
    previous,
}: {
    current: number
    previous: number
}) => ((current - previous) * 100) / previous
